export default __webpack_public_path__ + "locales/ro/Webhooks.json?hash=c0197ac7e294ca51222467f7f67aa915";